import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { PageProvider } from './PageContext';
import { Facebook } from './components/Facebook';
import { GTM } from './components/Gmt';
import { StackAdapt } from './components/StackAdapt';
import { AgeGate } from './components/AgeGate';
import { ConsentProvider } from './ConsentContext';
import Home from './pages/Home';
import News from './pages/News';
import Slug from './pages/...slug';
import Faq from './pages/Faq';
import NotFound from './pages/NotFound';

import './styles/App.scss';

const App: React.FC = () => {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <ConsentProvider>
        <Facebook />
        <GTM />
        <StackAdapt />
        <AgeGate />
        <PageProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about/" element={<Home />} />
            <Route path="/media/" element={<Home />} />
            <Route path="/news/" element={<News />} />
            <Route path="/faq/" element={<Faq />} />
            <Route path="/news/:slug/" element={<Slug />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </PageProvider>
      </ConsentProvider>
    </Router>
  );
};

export default App;
